<template src="./module_4.html">

</template>

<style src="./module_4.scss" lang="scss" scoped></style>

<script>
  import anime from 'animejs';
  import {
    createBlinkAnimation
  } from '@/assets/js/utils/createBlinkAnimation';
  import animations from '@/assets/js/animations';
  import * as contentful from 'contentful';

  import quiz from './quiz' // modal component

  export default {
    components: {
      'quiz': quiz
    },
    data() {
      return {
        // store animation to pause
        ulmBackgroundAnimation: null,
        // scene transition between library and lab
        showSceneTransition: false,
        // modal data
        modalText: [
          [
            "Before you launch the animation, please assign the following speaking roles to students in the classroom. Readers will know it is their turn to speak when their character’s icon appears to the left of the text box.",
            "Student One: Aye", "Student Two: Ria"
          ],
        ],
        modalActive: false,
        modalInd: 0,
        modalStyle: {
          'background': '#DFC8E4'
        },
        //
        lib_ready_state: {
          lib_doors_active: true,
          lib_doors_visible: false
        },
        library_doors: true,
        library_background_state: 'active',
        lab_background_state: '',
        lab_ready_state: {
          lab_doors_active: false,
          lab_doors_visible: true
        },
        scene_background_state: '',
        lab_interaction: true,
        aye_state: ["smile", "green"],
        text: null,
        // MODULE + CONTROL PANEL
        active_text: null,
        control_panel_active: false,
        module_complete: false,

        // AYE
        aye_attention_state: '',
        aye_arm_rotation_state: '',

        // RIA
        ria_speaking: false,
        ria_hand_flip: '',
        ria_arm_cross_state: {
          cross_arm_active: false,
          cross_arm_visible: false,
          default_arm_active: true,
          default_arm_visible: true
        },

        // SKYLAR
        skylar_mouth_state: false,
        skylar_present: '',

        // DYLAN
        dylan_mouth_state: false,
        dylan_present: '',
        dylan_double_right_hand: '',
        dylan_default_right_hand: 'active',

        // MR ULM
        mr_ulm_present: '',
        mr_ulm_arm_switch_state: '',
        mr_ulm_standing_state: '',
        mr_ulm_walking_state: '',
        mr_ulm_head_turn_state: '',
        mr_ulm_head_stuck_state: '',

        // BACKGROUND
        excess_doors_present: '',

        // MODAL
        modal_active: false,
        modal_ready: false,
        // determines text on modal
        quiz_question: 1,
        // determines if modal has question or explanation
        content_type: '',

        // turns button blue when active
        healthy_selection_state: '',
        red_flag_selection_state: '',
        answer_selection: '',
        active_question: false,


        // explains correct or incorrect reasoning
        selected_answer: '',
        modal_type: '',

        // AUDIO
        library_audio: new Audio('static/audio/module_4/library.wav'),
        lab_audio: new Audio('static/audio/module_1/lab_background.mp3')
      }
    },

    mounted() {

      // open initial modal
      this.modalActive = true

      this.library_audio.loop = true;
      this.library_audio.play();

      // blinking animations
      createBlinkAnimation("skylar");

      anime({
        delay: 600,
        begin: () => {
          createBlinkAnimation("dylan");
        }
      });


      // ulm background animation (head turn)
      this.ulmBackgroundAnimation = anime({ // loop this
        targets: '#ulm_head_container_two',
        scaleX: [{
          value: '-1',
          duration: 0,
          // easing: 'linear'
        }, {
          value: '1',
          duration: 1,
          // easing: 'linear',
          delay: 2500
        }],
        duration: 12500,
        easing: 'linear',
        loop: true,
        strokeDashoffset: [36, anime.setDashoffset],
      })

      const content_client = contentful.createClient({
        space: process.env.SPACE_ID,
        accessToken: process.env.CMS_TOKEN
      });

      content_client.getEntries({
        content_type: 'module',
        'fields.module_number': 4
      }).then((response) => {
        this.text = response.items[0].fields.module_text.map((data) => {
          let temp;
          if (data.fields.speaker) {
            temp = {
              id: data.fields.id,
              speaker: data.fields.speaker,
              string: data.fields.text.replace(/\n/g, "<br/>")
            }
          } else {
            temp = {
              id: data.fields.id,
              string: data.fields.text.replace(/\n/g, "<br/>")
            }
          }
          return temp;
        });

        this.active_text = this.text[0];
      }).catch(console.error);
    },


    methods: {
      // close modal
      closeModal() {
        this.modalActive = false
      },
      //
      open_library() {
        this.library_audio.play() // safari fix
        // console.log('should open')
        if (this.module_complete == false) {
          let new_id = this.text.indexOf(this.active_text) + 1;
          this.active_text = this.text[new_id];

          let door_sound = new Audio('static/audio/module_1/door_open.wav');
          door_sound.play();
          // door_sound.volume = 0;

          anime({
            targets: '#library_doors #left_library_door',
            translateX: '-100%',
            easing: 'easeOutQuart',
            duration: 2000,
            complete: () => {
              this.lib_ready_state.lib_doors_active = false;
              this.lib_ready_state.lib_doors_visible = false;
            }
          });

          anime({
            targets: '#library_doors #right_library_door',
            translateX: '100%',
            duration: 2000,
            easing: 'easeOutQuart'
          });

          anime({
            targets: '#aye',
            translateY: [{
                value: '10px'
              },
              {
                value: '0'
              },
              {
                value: '10px'
              },
              {
                value: '0'
              }
            ],
            left: ['-20%', '0%'],
            easing: 'linear',
            duration: 2000,
            complete: () => {
              this.control_panel_active = true;
            }
          });

          const graph_anchors = [{
              from_y: 326,
              to_y: 285
            },
            {
              from_y: 243,
              to_y: 305
            },
            {
              from_y: 305,
              to_y: 264
            },
            {
              from_y: 285,
              to_y: 326
            },
            {
              from_y: 325,
              to_y: 285
            }
          ];

          const graph_path_data_from = 'M929.12 324.54l46.14 -39.52 48.08 19.8 46.97 -62.55 47.24 84.27';
          const graph_path_data_to = 'M929.12 284.54l47.14 41.48 47.08 -62.2 46.97 41.45 47.24 -20.73';

          anime({
            targets: '.line_graph_first_anchor',
            cy: [{
                value(el, i) {
                  return graph_anchors[i].to_y;
                },
                delay: 5000
              },
              {
                value(el, i) {
                  return graph_anchors[i].from_y;
                },
                delay: 5000
              }
            ],
            easing: 'easeOutCubic',
            loop: true
          });

          anime({
            targets: '#line_graph_first_path',
            d: [{
                value: graph_path_data_to,
                delay: 5000
              },
              {
                value: graph_path_data_from,
                delay: 5000
              }
            ],
            easing: 'easeOutCubic',
            loop: true
          });

          let motion_paths = {
            path_1: anime.path('#radar_path_1'),
            path_2: anime.path('#radar_path_2'),
            path_3: anime.path('#radar_path_3')
          }

          anime({
            targets: '#radar_point_1',
            cy: motion_paths.path_1('y'),
            cx: motion_paths.path_1('x'),
            easing: 'linear',
            duration: 10000,
            loop: true
          });

          anime({
            targets: '#radar_point_2',
            cy: motion_paths.path_2('y'),
            cx: motion_paths.path_2('x'),
            easing: 'linear',
            duration: 7000,
            loop: true
          });

          anime({
            targets: '#radar_point_3',
            cy: motion_paths.path_3('y'),
            cx: motion_paths.path_3('x'),
            easing: 'linear',
            duration: 5000,
            loop: true
          });
        }
      },

      aye_attention_trigger() {
        console.log('attention');
        this.aye_attention_state = 'active';

        anime({
          targets: '#aye_attention .attention',
          strokeDashoffset: [36, anime.setDashoffset],
          easing: 'linear'
        });
      },

      aye_arm_rotation_trigger() {
        console.log('attention');
        this.aye_arm_rotation_state = 'active';

        anime({
          targets: '#aye_left_forearm_rotation .arm_rotate',
          strokeDashoffset: [36, anime.setDashoffset],
          easing: 'linear'
        });
      },

      ulm_head_turn_trigger() {
        this.mr_ulm_head_turn_state = 'active';
        console.log(this.mr_ulm_head_turn_state);

        anime({
          targets: '#ulm_head_container',
          scaleX: {
            value: '-1',
            duration: 0,
            easing: 'linear'
          },
          strokeDashoffset: [36, anime.setDashoffset],
          easing: 'linear'
        });
      },

      ulm_standing_trigger() {
        this.mr_ulm_arm_switch_state = 'active';
        this.mr_ulm_standing_state = 'active';
        console.log(this.mr_ulm_standing_state);

        anime({
          targets: '#mr-ulm',
          scaleX: {
            value: '-1',
            duration: 0,
            easing: 'linear'
          },
          strokeDashoffset: [36, anime.setDashoffset],
          easing: 'linear'
        });
      },

      ria_arm_cross_trigger() {
        let timeline = anime.timeline();

        timeline.add({
          targets: '#ria_left_arm, #ria_left_cross_arm_group',
          rotate: '100deg',
          easing: 'easeOutCubic',
          delay: 400,
          begin: () => {
            this.ria_arm_cross_state.cross_arm_active = true;
            this.ria_arm_cross_state.cross_arm_visible = true;
            this.ria_arm_cross_state.default_arm_active = false;
            this.ria_arm_cross_state.default_arm_visible = false;
          }
        }).add({
          targets: '#ria_left_arm_top',
          rotate: '0deg',
          easing: 'easeOutCubic',
          offset: '-=400'
        })
      },

      ria_arm_uncross_trigger() {
        let timeline = anime.timeline();

        timeline.add({
          targets: '#ria_left_arm, #ria_left_cross_arm_group',
          rotate: '0deg',
          easing: 'easeOutCubic',
          delay: 400,
          complete: () => {
            this.ria_arm_cross_state.cross_arm_active = false;
            this.ria_arm_cross_state.cross_arm_visible = false;
            this.ria_arm_cross_state.default_arm_active = true;
            this.ria_arm_cross_state.default_arm_visible = true;
          }
        })
      },

      toggle_lab_background() {
        this.library_audio.loop = false;

        // this.lab_audio.loop = true;
        // this.lab_audio.play();

        this.lab_background_state = 'active';
        this.scene_background_state = 'active';
        this.library_background_state = '';
        this.lab_interaction = true;

        anime({
          targets: '#lab-background .lab',
          easing: 'linear'
        });
      },

      ria_speech(count, delay) {
        let temp = count - 1;
        if (temp > 0) {
          this.ria_speaking = true;
          setTimeout(() => {
            this.ria_speaking = false;
            setTimeout(() => {
              this.ria_speech(temp, delay);
            }, delay);
          }, delay);
        }
      },

      close_doors() {
        anime({
          begin: () => {
            this.lab_ready_state.lab_doors_visible = false;
            this.lab_ready_state.lab_doors_active = true;
            let door_sound = new Audio('static/audio/module_1/door_open.wav');
            door_sound.play();
          },
          targets: '#lab_full_right_door',
          translateX: ['640px', '0px'],
          easing: 'easeOutQuart',
          duration: 2000
        });

        anime({
          targets: '#lab_full_left_door',
          translateX: ['-640px', '0px'],
          easing: 'easeOutQuart',
          duration: 2000
        });
        return this.modal_active = this.modal_ready;
      },

      text_update() {
        let new_id = this.text.indexOf(this.active_text) + 1;
        if (this.control_panel_active && !this.modal_ready) {

          this.control_panel_active = false;
          this.active_text = this.text[new_id];

          if (this.active_text.speaker) {
            let current_speaker = this.active_text.speaker.toLowerCase();

            if (current_speaker == 'ria') {
              this.ria_speech(3, 500);
            }
          }
        }

        let timeline = anime.timeline();
        console.log(new_id + 1);

        switch (new_id + 1) {
          case 3:
            this.control_panel_active = true;

            // testing
            // this.mrUlmBackgroundAnimation = anime({
            //   targets: '#mr_ulm_left_forearm_hand_outer',
            //   rotate: ['10deg', '0deg', '0deg', '0deg', '0deg', '10deg', '10deg', '0deg', '0deg'],
            //   duration: 2500,
            //   easing:'linear',
            //   loop: true,
            //   delay: 1000
            // })

            break;
          case 4:
            this.control_panel_active = false;
            this.aye_state = ['unsure', 'orange'];

            timeline.add({
              targets: '#dylan',
              translateX: [{
                  value: '0'
                },
                {
                  value: '-130'
                }
              ],
              translateY: [{
                  value: '0px'
                },
                {
                  value: '-10px'
                },
                {
                  value: '0px'
                },
                {
                  value: '-10px'
                },
                {
                  value: '0px'
                }
              ],
              easing: 'linear',
              duration: 1000,
              complete: () => {
                this.aye_attention_trigger();
              }
            }).add({
              targets: '#dylan_mouth_top',
              translateY: [{
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                }
              ],
            }).add({
              targets: '#dylan_mouth_bottom',
              translateY: [{
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                }
              ],
              // offset: '-=1000'
            }).add({
              targets: '#aye #aye_attention',
              easing: 'easeOutCubic',
              // offset: '-=1000',
              delay: 1500,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 5:
            this.control_panel_active = false;
            this.aye_attention_state = '';
            this.aye_state = ['frown', 'red_orb'];

            timeline.add({
              targets: '#dylan_mouth_top, #dylan_mouth_bottom',
              translateY: [{
                value: 0
              }, ],
              duration: 1000
            }).add({
              delay: 500,
              targets: '#skylar_mouth_top',
              translateY: [{
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                }
              ],
              offset: '-=1000'
            }).add({
              targets: '#skylar_mouth_bottom',
              translateY: [{
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                }
              ],
              offset: '-=1000'
            }).add({
              begin: () => {
                this.dylan_default_right_hand = '';
                this.dylan_double_right_hand = 'active';
              },
              // , #dylan_second_hand
              // targets: '#dylan_right_arm_bottom', //, #dylan_second_hand',
              targets: '#dylan_right_forearm',
              rotate: '95deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#dylan_right_arm_top',
              rotate: '5deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#skylar_right_forearm_hand',
              rotate: '-55deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#skylar_left_forearm_hand',
              rotate: '-155deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              delay: 500,
              complete: () => {
                this.ulm_head_turn_trigger();
              }
            }).add({
              targets: '#aye_right_forearm_hand',
              rotate: '100deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              delay: 1000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 6:
            timeline.add({
              targets: '#skylar_mouth_top, #skylar_mouth_bottom',
              translateY: [{
                value: 0
              }, ],
              duration: 1000
            }).add({
              targets: '#dylan_mouth_top',
              translateY: [{
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                }
              ],
              offset: '-=1000'
            }).add({
              targets: '#dylan_mouth_bottom',
              translateY: [{
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                }
              ],
              offset: '-=1000'
            }).add({
              targets: '#aye_left_forearm',
              rotate: '100deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              delay: 3000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 7:

            this.ulmBackgroundAnimation.pause()
            anime({
              targets: '#ulm_head_container_two',
              scaleX: 1,
              duration: 0
            })

            this.aye_state = ['neutral', 'red_orb'];
            this.mr_ulm_standing_state = 'active';

            timeline.add({
              begin: () => {
                this.mr_ulm_head_stuck_state = 'stick';
                this.ulm_standing_trigger();
              },
              targets: "#mr_ulm",
              scaleX: {
                value: '-1',
                duration: 0,
                easing: 'linear'
              },
              duration: 1000,
              easing: 'easeOutCubic',
            }).add({
              targets: "#ulm_right_arm",
              translateX: '-10px',
              translateY: '-5px',
              rotate: '20deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#ulm_mouth_top',
              translateY: [{
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                }
              ],
              offset: '-=1000',
              duration: 1200
            }).add({
              targets: '#ulm_mouth_bottom',
              translateY: [{
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                }
              ],
              offset: '-=1200',
            }).add({
              targets: "#ulm_right_arm",
              translateX: '10px',
              translateY: '5px',
              rotate: '0deg',
              easing: 'easeOutCubic',
              duration: 1000,
              complete: () => {
                this.mr_ulm_arm_switch_state = '';

                anime({
                  targets: "#mr_ulm_left_forearm_hand",
                  rotate: '90deg',
                  duration: 0,
                  easing: 'easeOutCubic',
                  translateX: '50px',
                  translateY: '24px'
                })
              }
            })

            timeline.add({
              begin: () => {
                this.mr_ulm_walking_state = 'active';
              },
              targets: '#ulm-on-the-move',
              translateX: [
                // { value: '50' },
                // { value: '122' },
                // { value: '224' },
                // { value: '306' },
                // { value: '358' },
                {
                  value: '400'
                }
              ],
              translateY: [{
                  value: '0'
                },
                {
                  value: '0'
                },

                {
                  value: '-8'
                },
                {
                  value: '0'
                },
                {
                  value: '-8'
                },
                {
                  value: '0'
                },
                {
                  value: '-8'
                },
                {
                  value: '0'
                },
                {
                  value: '-8'
                },
                {
                  value: '0'
                },

                {
                  value: '0'
                },
                {
                  value: '0'
                },

                {
                  value: '0'
                },
                {
                  value: '0'
                },
                {
                  value: '0'
                },
                {
                  value: '0'
                }
              ],
              easing: 'easeOutCubic',
              duration: 3000,
              complete: () => {
                this.control_panel_active = true;
              }
            }).add({
              targets: '#dylan_head',
              scaleX: {
                value: '-1',
                duration: 1,
                easing: 'linear'
              },
              easing: 'easeOutCubic',
              offset: '-=2500'
            }).add({
              targets: '#skylar_right_forearm_hand',
              rotate: '80deg',
              easing: 'easeOutCubic',
              duration: 900
            }).add({
              targets: '#skylar_left_forearm_hand',
              rotate: '-15deg',
              easing: 'easeOutCubic',
              offset: '-=900'
            }).add({
              // targets: //'#dylan_right_arm_bottom', // #dylan_second_hand',
              targets: '#dylan_right_forearm',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1200',
              // complete: () => {
              //   this.dylan_default_right_hand = 'active';
              //   this.dylan_double_right_hand = '';
              // }
            }).add({
              targets: '#dylan_right_arm_top',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1200'
            }).add({
              targets: '#dylan_mouth_top',
              translateY: [{
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                }
              ],
              duration: 1000
            }).add({
              targets: '#dylan_mouth_bottom',
              translateY: [{
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                }
              ],
              offset: '-=1000'
            }).add({
              targets: '#aye_left_forearm',
              rotate: '0deg',
              easing: 'easeOutCubic',
              duration: 1000,
            })

            timeline.add({
              targets: '#ulm_mouth_top',
              translateY: [{
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                },
                {
                  value: 0
                },
                {
                  value: -1
                }
              ],
              duration: 1000
            }).add({
              targets: '#ulm_mouth_bottom',
              translateY: [{
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                },
                {
                  value: 0
                },
                {
                  value: 1
                }
              ],
              offset: '-=1000',
              // delay: 1000,// 10000,
              // complete: () => { // moving somewhere earlier
              //   this.control_panel_active = true;
              // }
            });
            break;

          case 8:
            console.log(8)
            this.library_audio.pause()
            this.lab_audio.loop = true; // safari fix
            this.lab_audio.play()
            anime({
              targets: '#aye',
              left: ['0%', '-20%'],
              translateY: [{
                  value: '10px'
                },
                {
                  value: '0'
                },
                {
                  value: '10px'
                },
                {
                  value: '0'
                },
                {
                  value: '10px'
                },
                {
                  value: '0'
                },
                {
                  value: '10px'
                },
                {
                  value: '0'
                },
                {
                  value: '10px'
                },
                {
                  value: '0'
                },
                {
                  value: '10px'
                },
                {
                  value: '0'
                }
              ],
              scaleX: {
                value: '-1',
                duration: 1,
                easing: 'linear'
              },
              duration: 2800,
              easing: 'easeOutCubic',
              begin: () => { // transition backgrounds
                setTimeout(() => {
                  this.showSceneTransition = true
                }, 750)
              },
              complete: () => {
                setTimeout(() => {
                  this.showSceneTransition = false
                }, 750)
                this.dylan_default_right_hand = 'active';
                this.dylan_double_right_hand = '';
                this.toggle_lab_background();
                this.dylan_present = 'active';
                this.skylar_present = 'active';
                this.mr_ulm_present = 'active';
                this.excess_doors_present = 'active';
              }
            })

            timeline.add({
              delay: 2200,
              targets: '#ria',
              translateY: [{
                  value: '20px'
                },
                {
                  value: '0'
                },
                {
                  value: '20px'
                },
                {
                  value: '0'
                }
              ],
              left: ['-33%', '1%'],
              easing: 'linear',
              duration: 1000
            }).add({
              targets: '#aye',
              left: ['100%', '85%'],
              scaleX: {
                value: '-1',
                duration: 1,
                easing: 'linear'
              },
              translateY: [{
                  value: '10px'
                },
                {
                  value: '0'
                },
                {
                  value: '10px'
                },
                {
                  value: '0'
                }
              ],
              easing: 'easeOutCubic',
              duration: 2000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 9:
            this.control_panel_active = false;
            this.aye_state = ['neutral', 'red_orb'];

            timeline.add({
              targets: '#ria_default_left_arm_group',
              rotate: '-75deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#ria_left_arm_top',
              rotate: '-20deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              duration: 2000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 10:
            this.control_panel_active = false;
            this.aye_state = ['unsure', 'red_orb'];

            timeline.add({
              targets: '#ria_default_left_arm_group',
              rotate: '0deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#ria_left_arm_top',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#ria',
              translateY: [{
                  value: '10px'
                },
                {
                  value: '0'
                },
                {
                  value: '10px'
                },
                {
                  value: '0'
                }
              ],
              translateX: [{
                  value: '30%' // '100px'
                },
                {
                  value: '60%' // '200px'
                },
                {
                  value: '90%' // '300px' // todo: fix this to be percentages
                  // value: '300px'
                },
              ],
              easing: 'linear'
            }).add({
              targets: '#aye',
              left: ['85%', '59.5%'],
              scaleX: {
                value: '-1',
                duration: 1,
                easing: 'linear'
              },
              translateY: [{
                  value: '10px'
                },
                {
                  value: '0'
                },
                {
                  value: '10px'
                },
                {
                  value: '0'
                }
              ],
              easing: 'easeOutCubic',
              offset: '-=1000',
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 11:
            this.control_panel_active = false;
            this.aye_state = ['neutral', 'red_orb'];

            timeline.add({
              targets: '#ria_default_left_arm_group',
              rotate: '-75deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#ria_left_arm_top',
              rotate: '-20deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              duration: 2000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 12:
            this.control_panel_active = false;
            this.aye_state = ['unsure', 'red_orb'];

            timeline.add({
              targets: '#ria_default_left_arm_group',
              rotate: '0deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#ria_left_arm_top',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              duration: 1000
            }).add({
              targets: '#aye_right_forearm_hand',
              rotate: '100deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              duration: 1000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 13:
            this.control_panel_active = false;
            this.aye_arm_rotation_state = '';
            this.aye_state = ['neutral', 'red_orb'];

            // anime({
            //   targets: '#ria_right_arm_bottom, #ria_right_hand',
            //   rotate: '-90deg',
            //   easing: 'easeOutCubic',
            //   duration: 1000
            //   // duration: 900,
            //   // offset: '-=1000'
            // })

            // anime({
            //   begin: () => {
            //     this.ria_arm_cross_trigger();
            //   },
            //   targets: '#aye_left_arm_1, #aye_left_arm_2',
            //   rotate: '0deg',
            //   easing: 'easeOutCubic',
            //   duration: 1000
            // })

            timeline.add({
                targets: '#ria_right_arm_bottom, #ria_right_hand',
                rotate: '-90deg',
                easing: 'easeOutCubic',
                duration: 1000
                // targets: '#ria_left_arm_top',
                // rotate: '-5deg',
                // easing: 'easeOutCubic',
                // offset: '-=400'
              }).add({
                targets: '#aye_left_arm_3',
                rotate: '0deg',
                easing: 'easeOutCubic',
                offset: '-=1000'
              }).add({
                targets: '#aye_left_hand_1, #aye_left_hand_fingers',
                rotate: '0deg',
                easing: 'easeOutCubic',
                offset: '-=1000'
              })

              .add({
                targets: '#aye_left_forearm',
                rotate: '100deg',
                easing: 'easeOutCubic',
                duration: 1000,
              }).add({
                targets: '#aye_right_forearm_hand',
                rotate: '100deg',
                easing: 'easeOutCubic',
                duration: 1000,
                complete: () => {
                  this.control_panel_active = true;
                }
              });
            break;

          case 14:
            this.control_panel_active = false;
            this.aye_state = ['unsure', 'red_orb'];

            anime({
              targets: '#aye_left_forearm',
              rotate: '100deg',
              easing: 'easeOutCubic',
              duration: 1000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 15:
            this.control_panel_active = false;
            this.aye_state = ['frown', 'red_orb'];
            // this.ria_hand_flip = 'active';

            anime({
              targets: '#ria_left_arm, #ria_left_cross_arm_group',
              rotate: '0deg',
              easing: 'easeOutCubic',
              complete: () => {
                this.ria_arm_cross_state.cross_arm_active = false;
                this.ria_arm_cross_state.cross_arm_visible = false;
                this.ria_arm_cross_state.default_arm_active = true;
                this.ria_arm_cross_state.default_arm_visible = true;
              }
            })

            timeline.add({
              targets: '#ria_forearm',
              rotate: '-20deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#aye_right_forearm_hand',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#aye_left_forearm',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 16:
            this.control_panel_active = false;
            this.aye_state = ['unsure', 'red_orb'];

            timeline.add({
              targets: '#aye_left_arm_1, #aye_left_arm_2',
              rotate: '0deg',
              easing: 'easeOutCubic',
              duration: 1000,
              // added in to test.
              complete: () => {
                this.control_panel_active = true;
              }
            })

            /*
            .add({
              targets: '#ria_default_left_arm_group',
              rotate: '-135deg',
              easing: 'easeOutCubic',
              duration: 1000
              // }).add({
              //   targets: '#ria_left_arm_top',
              //   rotate: '-10deg',
              //   easing: 'easeOutCubic',
              //   offset: '-=1000'
            }).add({
              targets: '#ria_forearm',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#aye_right_forearm_hand',
              rotate: '100deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#aye_left_forearm',
              rotate: '100deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              complete: () => {
                this.control_panel_active = true;
              }
            });
            */
            break;

          case 17:
            this.control_panel_active = false;
            this.aye_state = ['neutral', 'red_orb'];

            anime({
              targets: '#ria_default_left_arm_group',
              rotate: '0deg',
              easing: 'easeOutCubic',
              duration: 1000,
              complete: () => {
                this.ria_arm_cross_trigger();
              }
            })

            timeline.add({
              delay: 1000,
              targets: '#aye_left_forearm',
              rotate: '0deg',
              easing: 'easeOutCubic',
            }).add({
              targets: '#ria_left_forearm_hand',
              rotate: '-70deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 18:
            console.log(18)
            this.control_panel_active = false;
            this.aye_state = ['unsure', 'red_orb'];

            anime({
              begin: () => {
                this.ria_arm_uncross_trigger()
              },
              targets: '#aye_left_forearm',
              rotate: '100deg',
              easing: 'easeOutCubic',
              duration: 1000
            })

            timeline.add({
              delay: 1500,
              begin: () => {
                this.aye_arm_rotation_state = '';
              },
              targets: '#ria_default_left_arm_group',
              rotate: '0deg', //'-90deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#ria_forearm',
              rotate: '0deg', // '90deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#ria_default_left_arm_group',
              rotate: '0deg', //'90deg',
              easing: 'easeOutCubic',
              duration: 1000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 19:
            console.log(19)
            this.control_panel_active = false;
            this.aye_state = ['frown', 'red_orb'];
            this.aye_arm_rotation_state = '';

            timeline.add({
              targets: '#ria_forearm',
              rotate: '-20deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#aye_right_forearm_hand',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#aye_left_forearm',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 20:
            console.log(20)
            this.control_panel_active = false;
            this.aye_state = ['unsure', 'red_orb'];
            this.aye_arm_rotation_state = '';

            anime({
              begin: () => {
                this.ria_arm_cross_trigger();
              },
              targets: '#ria_forearm',
              rotate: '0deg',
              easing: 'easeOutCubic',
              duration: 1000
            })

            timeline.add({
              targets: '#aye_left_arm_1, #aye_left_arm_2',
              rotate: '0deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#ria_left_arm_top',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=400'
            }).add({
              targets: '#aye_left_arm_3',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#aye_left_hand_1, #aye_left_hand_fingers',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#aye_left_forearm',
              rotate: '100deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#aye_right_forearm_hand',
              rotate: '135deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              duration: 1000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 21:
            console.log(21)
            this.control_panel_active = false;
            this.aye_state = ['frown', 'red_orb'];
            this.ria_arm_uncross_trigger();
            this.aye_arm_rotation_state = '';

            anime({
              begin: () => {
                this.aye_arm_rotation_state = '';
              },
              targets: '#ria_forearm',
              delay: 1500,
              rotate: '0deg', //'90deg',
              easing: 'easeOutCubic',
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 22:
            console.log(22)
            this.control_panel_active = false;
            this.aye_state = ['unsure', 'red_orb'];

            timeline
              // .add({
              //   targets: '#ria_default_left_arm_group',
              //   rotate: '-75deg',
              //   easing: 'easeOutCubic',
              //   duration: 1000
              // }).add({
              //   targets: '#ria_left_arm_top',
              //   rotate: '-20deg',
              //   easing: 'easeOutCubic',
              //   offset: '-=1000',
              //   duration: 2000,
              // })
              .add({
                targets: '#aye_right_forearm_hand',
                rotate: '100deg',
                easing: 'easeOutCubic',
                duration: 1000
              }).add({
                targets: '#aye_left_forearm',
                rotate: '100deg',
                easing: 'easeOutCubic',
                offset: '-=1000',
                complete: () => {
                  this.control_panel_active = true;
                }
              });
            break;

          case 23:
            console.log(23)
            this.control_panel_active = false;
            this.aye_state = ['frown', 'red_orb'];

            timeline.add({
              targets: '#aye_right_forearm_hand',
              rotate: '0deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#aye_left_forearm',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 24:
            console.log(24)
            this.control_panel_active = false;
            this.aye_state = ['unsure', 'red_orb'];

            anime({
              targets: '#aye_left_forearm',
              rotate: '100deg',
              easing: 'easeOutCubic',
              duration: 1000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 25:
            console.log(25)
            this.control_panel_active = false;
            this.aye_state = ['neutral', 'orange'];

            timeline.add({
              targets: '#ria_forearm',
              rotate: '-20deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#ria_default_left_arm_group, #ria_left_arm_top',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#aye_left_forearm',
              rotate: '0deg',
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#aye_right_forearm_hand',
              rotate: '100deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 26:
            console.log(26)
            this.control_panel_active = false;
            this.aye_state = ['frown', 'orange'];

            timeline.add({
              targets: '#ria_forearm',
              rotate: '0deg', // 90
              easing: 'easeOutCubic',
              duration: 1000
            }).add({
              targets: '#ria_default_left_arm_group',
              rotate: '-75deg',
              easing: 'easeOutCubic',
              offset: '-=1000'
            }).add({
              targets: '#ria_left_arm_top',
              rotate: '-20deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              duration: 2000,
            }).add({
              targets: '#aye_right_forearm_hand',
              rotate: '0deg',
              easing: 'easeOutCubic',
              offset: '-=1000',
              delay: 1000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 27:
            console.log(27)
            this.control_panel_active = false;
            this.modal_active = true;
            // this.module_complete = true;

            timeline.add({
              targets: '#aye_right_forearm_hand',
              rotate: '0deg',
              easing: 'easeOutCubic',
              duration: 1000,
              complete: () => {
                this.control_panel_active = true;
              }
            });
            break;

          case 28:
            console.log(28)
            // this.modal_active = false;
            this.control_panel_active = true;
            // this.close_doors();
            // this.lab_ready_state.lab_doors_active = true;
            // this.lab_ready_state.lab_doors_visible = true;

            // anime({
            //   begin: () => {
            //     this.lab_ready_state.lab_doors_visible = false;
            //     this.lab_ready_state.lab_doors_active = true;
            //     let door_sound = new Audio('static/audio/module_1/door_open.wav');
            //     door_sound.play();
            //   },
            //   targets: '#lab_full_right_door',
            //   translateX: ['640px', '0px'],
            //   easing: 'easeOutQuart',
            //   duration: 2000
            // });
            //
            // anime({
            //   targets: '#lab_full_left_door',
            //   translateX: ['-640px', '0px'],
            //   easing: 'easeOutQuart',
            //   duration: 2000
            // });
            break;
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// module_4.vue?120373ea